import { render, staticRenderFns } from "./ViewHealth.vue?vue&type=template&id=fb53cb40"
import script from "./ViewHealth.vue?vue&type=script&lang=js"
export * from "./ViewHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports